// app/src/features/timeline/components/TerminalSlot.jsx
// Moved verbatim out of ForecastLane.jsx (PKG-06 split 1): one component per file.
import { useLayoutEffect, useRef, useState } from "react";

/**
 * A settled scenario's panel: centred on its branch stream, but kept inside the visible
 * timeline (the `.evt-scroll` box), so the date axis and signal bar below it and the forecast
 * header above it never sit over its Clear scenario button. Measured against the box itself,
 * since the lanes sit under offsets this component cannot see.
 */
export default function TerminalSlot({ left, centerY, children, ...rest }) {
  const ref = useRef(null);
  const [shift, setShift] = useState(0);
  // No deps, on purpose: re-measured after every render, and settles at once (the guard below).
  /* eslint-disable-line react-hooks/exhaustive-deps -- see above */ useLayoutEffect(() => {
    const el = ref.current;
    const view = el?.closest(".evt-scroll");
    if (!el || !view) return;
    const b = el.getBoundingClientRect();
    const v = view.getBoundingClientRect();
    // Where it sits unshifted, then the least shift that keeps it inside, top edge first.
    const top = b.top - shift;
    const bottom = b.bottom - shift;
    const next = Math.round(Math.max(Math.min(0, v.bottom - 8 - bottom), v.top + 8 - top));
    if (next !== shift) setShift(next);
  });
  return (
    <div
      ref={ref}
      {...rest}
      style={{
        position: "absolute",
        left,
        top: centerY,
        transform: `translateY(calc(-50% + ${shift}px))`,
        zIndex: 30,
      }}
    >
      {children}
    </div>
  );
}
